<div class="flex flex-col gap-6" style="padding: 25px">
  <div class="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
    <div class="flex flex-col gap-1">
      <span class="text-black font-black uppercase">Classificação dos resultados do skincare</span>
      <small class="text-xs text-chathams-blue">
        Ajuste o padrão do sistema e, se necessário, personalize por empresa.
      </small>
    </div>

    <a
      routerLink="/dash/catalogo-produtos"
      class="h-9 px-4 btn btn--secondary inline-flex items-center justify-center whitespace-nowrap"
    >
      Abrir catálogo de produtos
    </a>
  </div>

  <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-6">
    <div class="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-bold uppercase text-chathams-blue">Configuração padrão</span>
        <small class="text-xs text-chathams-blue">
          Usada automaticamente quando a empresa não tiver uma configuração própria.
        </small>
      </div>
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <div class="xl:col-span-2 flex flex-col gap-4" [formGroup]="defaultThresholdForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div *ngFor="let field of thresholdFields" class="threshold-card">
            <div class="flex items-start justify-between gap-3">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-bold text-chathams-blue">{{ field.label }}</label>
                <small class="text-xs text-gray-500">Pontuação máxima da faixa</small>
              </div>

              <ng-container *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']">
                <button
                  *ngIf="!isInlineEditing('default', field.controlName)"
                  type="button"
                  class="value-chip"
                  (click)="startInlineEdit('default', field.controlName)"
                >
                  {{ getControlValue(defaultThresholdForm, field.controlName) ?? '--' }}
                </button>
              </ng-container>

              <input
                *ngIf="isInlineEditing('default', field.controlName)"
                [id]="getInlineInputId('default', field.controlName)"
                type="number"
                inputmode="numeric"
                class="form-input inline-value-input"
                [value]="getControlValue(defaultThresholdForm, field.controlName)"
                [min]="getRangeMin(defaultThresholdForm, field.controlName)"
                [max]="getRangeMax(defaultThresholdForm, field.controlName)"
                (blur)="commitInlineValue('default', field.controlName, $any($event.target).value)"
                (keydown.enter)="commitInlineValue('default', field.controlName, $any($event.target).value)"
                (keydown.escape)="cancelInlineEdit()"
              />
            </div>

            <input
              type="range"
              class="range-input"
              [formControlName]="field.controlName"
              [min]="getRangeMin(defaultThresholdForm, field.controlName)"
              [max]="getRangeMax(defaultThresholdForm, field.controlName)"
              step="1"
            />

            <div class="flex items-center justify-between text-xs text-gray-500">
              <span>{{ getRangeMin(defaultThresholdForm, field.controlName) }}</span>
              <span>{{ getRangeMax(defaultThresholdForm, field.controlName) }}</span>
            </div>
          </div>
        </div>

        <p
          class="text-xs text-cerise-red-600 m-0"
          *ngIf="!isLoadingDefaultThresholds && !isThresholdFormValid(defaultThresholdForm)"
        >
          {{ getThresholdValidationMessage(defaultThresholdForm) }}
        </p>

        <div class="flex flex-wrap items-center gap-3">
          <button
            *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
            type="button"
            class="h-9 px-4 btn btn--secondary"
            [disabled]="
              isLoadingDefaultThresholds || isSavingDefaultThresholds || !isThresholdFormValid(defaultThresholdForm)
            "
            (click)="saveDefaultThresholdSettings()"
          >
            {{ isSavingDefaultThresholds ? 'Salvando...' : 'Salvar configuração padrão' }}
          </button>
          <small class="text-xs text-chathams-blue" *ngIf="isLoadingDefaultThresholds"
            >Carregando configuração padrão...</small
          >
        </div>

        <small class="text-xs text-chathams-blue" *ngIf="defaultThresholdsMessage">{{
          defaultThresholdsMessage
        }}</small>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-200">
          <span class="text-xs font-bold uppercase text-chathams-blue">Prévia da classificação</span>
        </div>

        <ng-container *ngIf="getClassificationPreview(defaultThresholdForm).length; else defaultPreviewPlaceholder">
          <div *ngFor="let item of getClassificationPreview(defaultThresholdForm)" class="preview-row">
            <div class="flex items-center gap-3 min-w-0">
              <span class="preview-dot" [ngClass]="item.dotClass"></span>
              <span class="text-sm font-medium text-chathams-blue">{{ item.label }}</span>
            </div>
            <span class="text-sm text-chathams-blue text-right">{{ item.range }}</span>
          </div>
        </ng-container>

        <ng-template #defaultPreviewPlaceholder>
          <div class="p-4 text-sm text-chathams-blue">Ajuste as faixas para visualizar a classificação.</div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="bg-white rounded-2xl shadow-md p-6 flex flex-col gap-6">
    <div class="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-bold uppercase text-chathams-blue">Configuração por empresa</span>
        <small class="text-xs text-chathams-blue">
          Arraste o controle ou clique no número para editar manualmente.
        </small>
      </div>

      <span
        class="inline-flex items-center rounded-full px-3 py-1 text-xs font-bold w-fit"
        [ngClass]="hasCustomThresholds ? 'bg-amber-100 text-amber-800' : 'bg-gray-100 text-chathams-blue'"
      >
        {{ hasCustomThresholds ? 'Personalizada' : 'Usando padrão' }}
      </span>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-group md:col-span-2 xl:col-span-1">
        <label class="text-xs text-chathams-blue">Empresa</label>
        <ng-select
          notFoundText="Nenhuma empresa encontrada"
          [searchable]="true"
          placeholder="Selecione uma empresa"
          [formControl]="companyControl"
          (change)="onCompanySelectionChanged($event)"
        >
          <ng-option *ngFor="let company of companies" [value]="company.id">
            {{ company.name }}
          </ng-option>
        </ng-select>
        <small class="text-xs text-chathams-blue" *ngIf="companyControl.disabled">
          Sua conta está vinculada a uma empresa.
        </small>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-gray-50 p-4 flex flex-col gap-1" *ngIf="companyControl.value">
        <span class="text-xs font-bold uppercase text-chathams-blue">Empresa selecionada</span>
        <span class="text-sm font-bold text-chathams-blue">{{ getSelectedCompanyName() }}</span>
        <small class="text-xs text-chathams-blue">{{ companyThresholdsMessage }}</small>
      </div>
    </div>

    <div *ngIf="companyControl.value; else selectCompanyPlaceholder" class="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <div class="xl:col-span-2 flex flex-col gap-4" [formGroup]="companyThresholdForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div *ngFor="let field of thresholdFields" class="threshold-card">
            <div class="flex items-start justify-between gap-3">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-bold text-chathams-blue">{{ field.label }}</label>
                <small class="text-xs text-gray-500">Pontuação máxima da faixa</small>
              </div>

              <ng-container *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']">
                <button
                  *ngIf="!isInlineEditing('company', field.controlName)"
                  type="button"
                  class="value-chip"
                  (click)="startInlineEdit('company', field.controlName)"
                >
                  {{ getControlValue(companyThresholdForm, field.controlName) ?? '--' }}
                </button>
              </ng-container>

              <input
                *ngIf="isInlineEditing('company', field.controlName)"
                [id]="getInlineInputId('company', field.controlName)"
                type="number"
                inputmode="numeric"
                class="form-input inline-value-input"
                [value]="getControlValue(companyThresholdForm, field.controlName)"
                [min]="getRangeMin(companyThresholdForm, field.controlName)"
                [max]="getRangeMax(companyThresholdForm, field.controlName)"
                (blur)="commitInlineValue('company', field.controlName, $any($event.target).value)"
                (keydown.enter)="commitInlineValue('company', field.controlName, $any($event.target).value)"
                (keydown.escape)="cancelInlineEdit()"
              />
            </div>

            <input
              type="range"
              class="range-input"
              [formControlName]="field.controlName"
              [min]="getRangeMin(companyThresholdForm, field.controlName)"
              [max]="getRangeMax(companyThresholdForm, field.controlName)"
              step="1"
            />

            <div class="flex items-center justify-between text-xs text-gray-500">
              <span>{{ getRangeMin(companyThresholdForm, field.controlName) }}</span>
              <span>{{ getRangeMax(companyThresholdForm, field.controlName) }}</span>
            </div>
          </div>
        </div>

        <p
          class="text-xs text-cerise-red-600 m-0"
          *ngIf="!isLoadingCompanyThresholds && !isThresholdFormValid(companyThresholdForm)"
        >
          {{ getThresholdValidationMessage(companyThresholdForm) }}
        </p>

        <div class="flex flex-wrap items-center gap-3">
          <button
            *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
            type="button"
            class="h-9 px-4 btn btn--primary"
            [disabled]="
              !companyControl.value ||
              isLoadingCompanyThresholds ||
              isSavingCompanyThresholds ||
              isResettingCompanyThresholds ||
              !isThresholdFormValid(companyThresholdForm)
            "
            (click)="saveCompanyThresholdSettings()"
          >
            {{ isSavingCompanyThresholds ? 'Salvando...' : 'Salvar para esta empresa' }}
          </button>
          <button
            *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
            type="button"
            class="h-9 px-4 btn btn--secondary"
            [disabled]="
              !companyControl.value ||
              isLoadingCompanyThresholds ||
              isSavingCompanyThresholds ||
              isResettingCompanyThresholds ||
              !isThresholdFormValid(defaultThresholdForm)
            "
            (click)="copyDefaultToCompanyForm()"
          >
            Usar padrão como base
          </button>
          <button
            *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'skincare.edit']"
            type="button"
            class="h-9 px-4 btn btn--secondary"
            [disabled]="
              !companyControl.value ||
              isLoadingCompanyThresholds ||
              isSavingCompanyThresholds ||
              isResettingCompanyThresholds
            "
            (click)="resetCompanyThresholdSettings()"
          >
            {{ isResettingCompanyThresholds ? 'Voltando ao padrão...' : 'Voltar ao padrão do sistema' }}
          </button>
          <small class="text-xs text-chathams-blue" *ngIf="isLoadingCompanyThresholds"
            >Carregando configuração da empresa...</small
          >
        </div>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-200">
          <span class="text-xs font-bold uppercase text-chathams-blue">Prévia da classificação</span>
        </div>

        <ng-container *ngIf="getClassificationPreview(companyThresholdForm).length; else companyPreviewPlaceholder">
          <div *ngFor="let item of getClassificationPreview(companyThresholdForm)" class="preview-row">
            <div class="flex items-center gap-3 min-w-0">
              <span class="preview-dot" [ngClass]="item.dotClass"></span>
              <span class="text-sm font-medium text-chathams-blue">{{ item.label }}</span>
            </div>
            <span class="text-sm text-chathams-blue text-right">{{ item.range }}</span>
          </div>
        </ng-container>

        <ng-template #companyPreviewPlaceholder>
          <div class="p-4 text-sm text-chathams-blue">Ajuste as faixas para visualizar a classificação.</div>
        </ng-template>
      </div>
    </div>

    <ng-template #selectCompanyPlaceholder>
      <div class="rounded-2xl border border-dashed border-gray-300 p-4 text-sm text-chathams-blue">
        Selecione uma empresa para configurar a classificação.
      </div>
    </ng-template>
  </div>
</div>
